export const FLEECE_APPROVAL_REQUEST = "FLEECE_APPROVAL_REQUEST";
export const FLEECE_APPROVAL_SUCCESS = "FLEECE_APPROVAL_SUCCESS";
export const FLEECE_APPROVAL_FAILED = "FLEECE_APPROVAL_FAILED";
